import { WorkVehicleType } from './types';

export const mockData: WorkVehicleType[] = [
  {
    plate: '1234ABC',
    model: 'FORD TRANSIT',
    category: 'Furgoneta',
    ownership: 'INTERNAL',
  },
  {
    plate: '5678DEF',
    model: 'MERCEDES SPRINTER',
    category: 'Furgoneta',
    ownership: 'EXTERNAL',
  },
];
